import {Link} from '@ezcater/tapas';
import {useRouter} from 'next/router';
import useTranslation from 'next-translate/useTranslation';

import {EzcaterLogo} from '@/components/ui';
import Modal from '@/components/ui/Modal';
import useIdentity from '@/hooks/useIdentity';
import {ROOT_PATH} from '@/paths';
import AboutUsMenu from './AboutUsMenu';
import CompanyMenu from './CompanyMenu';
import ContactUsMenu from './ContactUsMenu';
import RestaurantMenu from './RestaurantMenu';
import UserMenu from './UserMenu';

type MenuModalProps = {
  onDismiss: () => void;
};

const MenuModal: React.FC<MenuModalProps> = ({onDismiss}) => {
  const {isLoggedIn} = useIdentity();
  const router = useRouter();
  const {t} = useTranslation('app-bar');
  const isLoggedOutHomepage = !isLoggedIn && router.pathname === ROOT_PATH;

  return (
    <Modal
      ariaLabel={t('menus.label') || 'Menu'}
      onOpenChange={isOpen => !isOpen && onDismiss()}
      open
      size="small"
      slotProps={{content: {className: 'p-0'}}}
      title={
        <div className="flex h-10 items-center">
          <EzcaterLogo />
        </div>
      }
    >
      <div className="flex flex-col">
        <div className="flex flex-col gap-6 px-4 py-6 tablet:px-6">
          {isLoggedOutHomepage && (
            <>
              <div className="px-4">
                <div className="font-bold leading-5 text-peppercorn-500">
                  {t('menus.welcomeToEzCater')}
                </div>
              </div>
              <div className="flex flex-col">
                <CompanyMenu isAccordion />
                <RestaurantMenu isAccordion />
                <AboutUsMenu isAccordion />
                <ContactUsMenu />
              </div>
            </>
          )}

          <UserMenu isMobileMenu isLoggedOutHomepage={isLoggedOutHomepage} />

          <div className="mt-4 flex flex-col items-start gap-1 rounded-xl bg-peppercorn-100 p-4">
            <div className="font-bold leading-5 text-peppercorn-500">{t('menus.needHelp')}</div>

            <Link
              className="-mb-1 text-peppercorn-800 hover:text-peppercorn-800 active:text-peppercorn-800"
              href={t('navLinks.supportPhoneNumberTel')}
            >
              {t('navLinks.supportPhoneNumber')}
            </Link>

            <Link
              className="text-peppercorn-800 hover:text-peppercorn-800 active:text-peppercorn-800"
              href={t('navLinks.supportEmailMailTo')}
            >
              {t('navLinks.supportEmail')}
            </Link>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default MenuModal;
